import { Role } from 'types/__generated__/types';

export const hasUserRole = (roles: Role[], role: Role): boolean => !!roles.find(r => r === role);

export const hasAllRoles = (userRoles: Role[], roles: Role[]): boolean => roles.every(r => hasUserRole(userRoles, r));

export const hasOneOfRoles = (userRoles: Role[], roles: Role[]): boolean => roles.some(r => hasUserRole(userRoles, r));
